import { Link } from 'react-router-dom';
import VideoHero from '@/components/promo/VideoHero';
import SepLine from '@/components/promo/SepLine';
import LetsTalk from '@/components/promo/LetsTalk';

export default function Influencers() {
  return (
    <div id="influencers">
      {/* Hero */}
      <VideoHero videoSrc="/assets/videos/influencers.mp4" imageSrc="/assets/images/influencers.png">
        <h1>GAME ON</h1>
        <h2>
          CONNECT WITH TOP BRANDS<br />AND GET REWARDED
        </h2>
        <SepLine />
        <div style={{ marginTop: 20 }}>
          <Link to="/login" className="btn-gc">LET'S GET STARTED</Link>
        </div>
      </VideoHero>

      {/* Slogans */}
      <div className="page-content" style={{ paddingBottom: 0 }}>
        <div className="inf-slogans" style={{ maxWidth: 1100, margin: '0 auto', padding: '40px 20px' }}>
          <h3>You call the shots</h3>
          <SepLine invisible />

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 30 }}>
            <div className="inf-slogan-item">
              <img className="slogan-icon" src="/assets/images/Slide16_Icon_01.png" alt="" />
              <div>
                <h4>NO CATCHES.<br />NO SURPRISES.</h4>
                <p className="slogan-text">
                  Any influencer with 10,000 average viewership can sign up! We'll work with your
                  channel and create an effective plan to grow your social platform alongside ours.
                  We have new campaigns every month.
                </p>
              </div>
            </div>

            <div className="inf-slogan-item">
              <img className="slogan-icon" src="/assets/images/Slide16_Icon_02.png" alt="" />
              <div>
                <h4>PAY WITHIN 48 HOURS</h4>
                <p className="slogan-text">
                  We pay the creator within 48 hours after releasing the content on their channels.
                  You'll be able to check out your stats and earnings in the GG Content dashboard.
                </p>
              </div>
            </div>

            <div className="inf-slogan-item">
              <img className="slogan-icon" src="/assets/images/Slide16_Icon_03.png" alt="" />
              <div>
                <h4>BUILD STRONG RELATIONSHIP<br />WITH THE WORLD'S TOP BRANDS</h4>
                <p className="slogan-text">
                  We help you build strong relationships with the world's best brands while
                  preserving your creativity and originality.
                </p>
              </div>
            </div>
          </div>
        </div>

        <SepLine />

        {/* Influencer Quotes */}
        <div style={{ maxWidth: 800, margin: '0 auto', padding: '20px 20px 40px', textAlign: 'center' }}>
          <h3 style={{ fontSize: 22, letterSpacing: 4, color: '#333', marginBottom: 30 }}>
            WHAT OUR INFLUENCERS ARE SAYING
          </h3>

          <div style={{ background: '#f9f9f9', borderRadius: 4, padding: '40px 30px', marginBottom: 30 }}>
            <p style={{ fontSize: 15, lineHeight: 1.8, color: '#555', fontStyle: 'italic', marginBottom: 20 }}>
              "GGContent helps me grow my brand globally. I get to work with international
              companies on interesting, successful games. My subscribers love the fact that I am
              introducing them to cool new products. I get the best of both worlds."
            </p>
            <h4 style={{ color: '#333', fontSize: 16, letterSpacing: 2, marginBottom: 4 }}>HYUN'S DOJO</h4>
            <p style={{ color: 'var(--vivid-green)', fontSize: 13, fontWeight: 700 }}>2.08M+ SUBSCRIBERS</p>
          </div>

          <div style={{ background: '#f9f9f9', borderRadius: 4, padding: '40px 30px' }}>
            <p style={{ fontSize: 15, lineHeight: 1.8, color: '#555', fontStyle: 'italic', marginBottom: 20 }}>
              "My passion is making videos and games, not negotiating with advertisers.
              GGContent lets me do what I love and they take care of the other stuff.
              I make money while having fun."
            </p>
            <h4 style={{ color: '#333', fontSize: 16, letterSpacing: 2, marginBottom: 4 }}>PIANTA</h4>
            <p style={{ color: 'var(--vivid-green)', fontSize: 13, fontWeight: 700 }}>526K+ SUBSCRIBERS</p>
          </div>
        </div>

        <SepLine />

        {/* How It Works */}
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '20px 20px 40px' }}>
          <h3 style={{ textAlign: 'center', fontSize: 24, letterSpacing: 4, color: '#333', marginBottom: 10 }}>
            HOW IT WORKS
          </h3>
          <SepLine invisible />

          <div className="grand-numbers">
            <div className="grand-number-block">
              <div className="grand-number">1</div>
              <div className="grand-number-content">
                <h4>SIGN UP</h4>
                <p>
                  Register now to get notifications on the latest campaigns for you.
                </p>
              </div>
            </div>
            <div className="grand-number-block">
              <div className="grand-number">2</div>
              <div className="grand-number-content">
                <h4>CREATE CONTENT</h4>
                <p>
                  Choose the best campaign for your channel and work directly with
                  a GGContent team to create the best sponsored content possible.
                  Publishers will share their guidelines and the rest is up to you.
                </p>
              </div>
            </div>
            <div className="grand-number-block">
              <div className="grand-number">3</div>
              <div className="grand-number-content">
                <h4>GET PAID</h4>
                <p>
                  We pay you based on your recent video viewership and the performance
                  quality of your channel. You'll be able to check out your stats and
                  earnings in your GGContent dashboard.
                </p>
              </div>
            </div>
          </div>
        </div>

        <LetsTalk />
      </div>
    </div>
  );
}
